export var FRAMEWORK = {
  None: '0',
  ReactNative: '1'
};
export var AUTH_CATEGORY = 'auth';


//////////////////
// WEBPACK FOOTER
// ./node_modules/amazon-cognito-identity-js/es/Platform/constants.js
// module id = null
// module chunks = 